<template>
    <div class="gauge-container">
      <div class="header">
        <h1>二级漏损率</h1>
      </div>
      
      <div class="chart-container">
        <div class="chart-wrapper">
          <div ref="chart" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // 注意：在Vue项目中需要先安装echarts: npm install echarts
  import * as echarts from 'echarts'

  
  export default {
    name: 'GaugeChart',
    props: {
      value: {
        type: Number,
        default: 0
      },
      title: {
        type: String,
        // default: '完成率'
      },
      colors: {
        type: Array,
        default: () => ['#37A2DA', '#32C5E9', '#67E0E3']
      }
    },
    data() {
      return {
        myChart: null,
        dataArr: this.value
      }
    },
    watch: {
      value(newVal) {
        this.dataArr = newVal
        this.updateChart()
      },
      title() {
        this.updateChart()
      },
      colors() {
        this.updateChart()
      }
    },
    computed: {
      chartOption() {
        return {
          backgroundColor: "transparent",
          color: this.colors,
          grid: {
            left: '20%',
            right: '20%',
            top: '18%',
            bottom: '18%',
            containLabel: true
          },
          series: [{
            name: '业务指标',
            type: 'gauge',
            radius: '65%',
            center: ['50%', '55%'],
            min: 0,
            max: 60,
            splitNumber: 6,
            startAngle: 200,
            endAngle: -20,
            progress: {
              show: true,
              width: 20,
              overlap: false
            },
            axisLine: {
              lineStyle: {
                width: 20,
                color: [
                  [0.33, this.colors[2] || '#67e0e3'],
                  [0.67, this.colors[0] || '#37a2da'],
                  [1, '#fd666d']
                ]
              }
            },
            axisTick: {
              distance: -35,
              splitNumber: 5,
              lineStyle: {
                width: 2,
                color: '#42E5FB'
              }
            },
            splitLine: {
              distance: -42,
              length: 10,
              lineStyle: {
                width: 2,
                color: '#42E5FB'
              }
            },
            axisLabel: {
              distance: 8,
              color: '#fff',
              fontSize: 13,
              fontWeight: 'bold',
              formatter: function(value) {
                return value
              }
            },
            pointer: {
              icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
              length: '65%',
              width: 5,
              offsetCenter: [0, '-10%'],
              itemStyle: {
                color: '#FFD700',
                shadowColor: 'rgba(255, 215, 0, 0.5)',
                shadowBlur: 10
              }
            },
            anchor: {
              show: true,
              size: 22,
              showAbove: true,
              itemStyle: {
                borderWidth: 5,
                borderColor: '#fff',
                color: '#FFD700',
                shadowColor: 'rgba(255, 215, 0, 0.8)',
                shadowBlur: 15
              }
            },
            detail: {
              valueAnimation: true,
              formatter: '{value}',
              color: '#fff',
              fontSize: 32,
              offsetCenter: [0, '70%'],
              fontWeight: 'bolder',
              textStyle: {
                textShadowColor: 'rgba(0, 0, 0, 0.5)',
                textShadowBlur: 5,
                textShadowOffsetX: 2,
                textShadowOffsetY: 2
              }
            },
            title: {
              offsetCenter: [0, '88%'],
              fontSize: 16,
              color: '#42E5FB',
              fontWeight: 'bold'
            },
            data: [{
              value: this.dataArr,
              name: this.title
            }]
          }]
        }
      }
    },
    mounted() {
      this.initChart()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
      if (this.myChart) {
        this.myChart.dispose()
      }
    },
    methods: {
      initChart() {
        this.myChart = echarts.init(this.$refs.chart)
        this.myChart.setOption(this.chartOption)
        
        // 添加事件监听
        this.addEventListeners()
      },
      handleResize() {
        if (this.myChart) {
          this.myChart.resize()
        }
      },
      addEventListeners() {
        // 添加点击事件
        this.myChart.on('click', (params) => {
          this.$emit('value-change', params.value)
          console.log('点击了仪表盘:', params.name, params.value)
        })
      },
      updateChart() {
        if (this.myChart) {
          this.myChart.setOption(this.chartOption)
        }
      },
      getValueColor() {
        if (this.dataArr < 30) {
          return this.colors[2] || '#67e0e3'
        } else if (this.dataArr < 70) {
          return this.colors[0] || '#37a2da'
        } else {
          return '#fd666d'
        }
      },
      getStatusText() {
        if (this.dataArr < 30) {
          return '较低'
        } else if (this.dataArr < 70) {
          return '中等'
        } else {
          return '较高'
        }
      },
      getStatusColor() {
        if (this.dataArr < 30) {
          return '#ff4d4f'
        } else if (this.dataArr < 70) {
          return '#faad14'
        } else {
          return '#52c41a'
        }
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .gauge-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
  .header {
    text-align: center;
    padding: 8px 10px;
    margin-bottom: 0;
    
    h1 {
      font-size: 20px;
      margin: 0;
      background: linear-gradient(90deg, #37A2DA, #67E0E3);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    
    p {
      color: #666;
      font-size: 16px;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.6;
    }
  }
  .chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 50px);
    padding: 0;
  }
  .chart-wrapper {
    width: 100%;
    height: 100%;
    // background: rgba(16, 23, 39, 0.6);
    border-radius: 8px;
    // box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
    padding: 10px;
    // border: 1px solid rgba(70, 142, 253, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .info-panel {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 20px;
    flex-wrap: wrap;
  }
  .info-item {
    background: #f8f9fa;
    padding: 15px 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.05);
    min-width: 150px;
    
    .label {
      font-size: 14px;
      color: #666;
      margin-bottom: 5px;
    }
    
    .value {
      font-size: 18px;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    .chart-wrapper {
      height: 400px;
      padding: 15px;
    }
    
    .header h1 {
      font-size: 26px;
    }
    
    .info-panel {
      flex-direction: column;
      align-items: center;
    }
    
    .info-item {
      width: 100%;
      max-width: 300px;
    }
  }
  </style>